// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Inactive Users Styles */
.inactive-users-container {
  padding: 24px;
}

.inactive-users-header {
  margin-bottom: 24px;
}

.inactive-users-title {
  font-size: 28px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 8px;
}

.inactive-users-subtitle {
  font-size: 14px;
  color: #666;
  margin-bottom: 16px;
}

.countries-filter-section {
  margin-top: 16px;
}

.filter-section {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
}

.data-grid-section {
  height: 500px;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/InactiveUsers.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;AACb","sourcesContent":["/* Inactive Users Styles */\n.inactive-users-container {\n  padding: 24px;\n}\n\n.inactive-users-header {\n  margin-bottom: 24px;\n}\n\n.inactive-users-title {\n  font-size: 28px;\n  font-weight: 600;\n  color: #1a1a1a;\n  margin-bottom: 8px;\n}\n\n.inactive-users-subtitle {\n  font-size: 14px;\n  color: #666;\n  margin-bottom: 16px;\n}\n\n.countries-filter-section {\n  margin-top: 16px;\n}\n\n.filter-section {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.data-grid-section {\n  height: 500px;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
